var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"mb-5"},[_c('b-link',{attrs:{"href":"#foo"}},[_vm._v("Link")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"mb-4"},[_c('strong',[_vm._v("Basic Usage")])])
}]

export { render, staticRenderFns }